import { render } from "./Service-card.component.vue?vue&type=template&id=b276e140&ts=true"
import script from "./Service-card.component.vue?vue&type=script&lang=ts"
export * from "./Service-card.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__